import {
  GiBarrel,
  GiCardExchange,
  GiCargoCrane,
  GiCargoShip,
  GiChemicalDrop,
  GiContract,
  GiDeliveryDrone,
  GiFactory,
  GiGears,
  GiMoneyStack,
  GiNotebook,
  GiOilDrum,
  GiPapers,
  GiPieChart,
  GiPriceTag,
  GiRadarSweep,
  GiReceiveMoney,
  GiSandsOfTime,
  GiScrollQuill,
  GiSteeringWheel,
  GiTestTubes,
  GiTicket,
  GiTrade,
  GiTruck,
} from 'react-icons/gi'

export const OBJECT_TYPES = {
  terminals: {
    name: 'Terminals',
    icon: GiOilDrum,
    description:
      'Physical locations where energy products are loaded and unloaded',
  },
  products: {
    name: 'Products',
    icon: GiChemicalDrop,
    description: 'Base petroleum ingredients and energy commodities',
  },
  sites: {
    name: 'Sites',
    icon: GiFactory,
    description: 'Physical facilities within the energy infrastructure network',
  },
  tanks: {
    name: 'Tanks',
    icon: GiBarrel,
    description: 'Physical underground storage tanks for petroleum products',
  },
  counterparties: {
    name: 'Counterparties',
    icon: GiTrade,
    description: 'Business entities in the energy supply chain',
  },
  tankModels: {
    name: 'Tank Models',
    icon: GiGears,
    description: 'Standardized specifications for storage tanks',
  },
  inventoryReadings: {
    name: 'Inventory Readings',
    icon: GiRadarSweep,
    description: 'Point-in-time measurements of product levels',
  },
  loadNumber: {
    name: 'Load Number',
    icon: GiPriceTag,
    description: 'Transactional identifier for loading operations',
  },
  allocations: {
    name: 'Allocations',
    icon: GiPieChart,
    description: 'Volume allocations for loading operations',
  },
  price: {
    name: 'Price',
    icon: GiReceiveMoney,
    description: 'Pricing information for products',
  },
  trucks: {
    name: 'Trucks',
    icon: GiTruck,
    description: 'Commercial vehicles for transporting products',
  },
  trailers: {
    name: 'Trailers',
    icon: GiCargoShip,
    description: 'Specialized tanker trailers for fuel transport',
  },
  drivers: {
    name: 'Drivers',
    icon: GiSteeringWheel,
    description: 'Licensed commercial drivers',
  },
  terminalCards: {
    name: 'Terminal Cards',
    icon: GiCardExchange,
    description: 'Access cards for terminal operations',
  },
  blendedProduct: {
    name: 'Blended Product',
    icon: GiTestTubes,
    description: 'Final marketable petroleum products',
  },
  freightRatebooks: {
    name: 'Freight Ratebooks',
    icon: GiNotebook,
    description: 'Transportation cost schedules',
  },
  deliveryRequest: {
    name: 'Delivery Request',
    icon: GiDeliveryDrone,
    description: 'Customer request for product delivery',
  },
  order: {
    name: 'Order',
    icon: GiScrollQuill,
    description: 'Confirmed delivery agreement',
  },
  bol: {
    name: 'BOL',
    icon: GiPapers,
    description: 'Bill of Lading - shipment receipt',
  },
  deliveryTicket: {
    name: 'Delivery Ticket',
    icon: GiTicket,
    description: 'Proof of delivery document',
  },
  supplyInvoice: {
    name: 'Supply Invoice',
    icon: GiMoneyStack,
    description: 'Supplier bill for products delivered',
  },
  freightInvoice: {
    name: 'Freight Invoice',
    icon: GiCargoCrane,
    description: 'Carrier bill for transportation services',
  },
  contracts: {
    name: 'Contracts',
    icon: GiContract,
    description: 'Legal agreements for supply chain operations',
  },
  terminalWaitTimes: {
    name: 'Terminal Wait Times',
    icon: GiSandsOfTime,
    description: 'Real-time wait time data at terminals',
  },
} as const

export type ObjectTypeKey = keyof typeof OBJECT_TYPES
